import React from 'react';
import { Formik, Form } from 'formik';

import { Grid } from '@mui/material';

import AggInventoryFilters from './AggInventoryFilters';
import { CircleLoading, DataTable, TablePagination } from 'shared';
import { aggregatedFileInventoryHeaders } from 'components/Inventory/utils/aggregatedFileInventoryTableHeaders';
import {
    purchaseActivityDateFields,
    purchaseActivitySearchByFields,
} from 'components/Inventory/utils/SelectActivityFilterFields';

function ModalPurchaseActivity({
    initialValues,
    validationSchema,
    unmatchedInventories,
    selectedRows,
    handleCheckboxChange,
    tableLoading,
    page,
    handlePageChange,
    handleGetAggregatedFileInventories,
    isMobileScreen,
    handleClearClick,
}) {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => handleGetAggregatedFileInventories(1, values, 'purchase')}
        >
            {({ values, handleReset, handleChange, setFieldValue }) => (
                <Form>
                    <AggInventoryFilters
                        values={values}
                        handleReset={handleReset}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        handleClearClick={handleClearClick}
                        searchByFields={purchaseActivitySearchByFields}
                        dateFields={purchaseActivityDateFields}
                    />

                    {unmatchedInventories ? (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <DataTable
                                    headCells={aggregatedFileInventoryHeaders(
                                        selectedRows,
                                        handleCheckboxChange,
                                    )}
                                    isLoading={tableLoading}
                                    data={unmatchedInventories.results}
                                />
                            </Grid>
                            <Grid item xs={12} p={'10px 0'}>
                                <TablePagination
                                    isMobileScreen={isMobileScreen}
                                    page={page}
                                    count={unmatchedInventories?.count}
                                    onChange={(e, pageNumber) =>
                                        handlePageChange(pageNumber, values)
                                    }
                                />
                            </Grid>
                        </Grid>
                    ) : (
                        <CircleLoading />
                    )}
                </Form>
            )}
        </Formik>
    );
}

export default ModalPurchaseActivity;
